export default "__VITE_ASSET__R67ctSyt__"